import { render, staticRenderFns } from "./AssessmentsAdd.vue?vue&type=template&id=e8d02310&"
import script from "./AssessmentsAdd.vue?vue&type=script&lang=js&"
export * from "./AssessmentsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports